import { Component, HostListener, OnInit } from '@angular/core';
import { BtnType } from '@shared/enums';
import { SpAuthService } from '@core/services/utility-services/auth.service';
import { UserContextService } from 'app/core/services/user-context.service';

@Component({
  selector: 'sp-session-timeout',
  template: `
    <div *ngIf="displayPopup">
      <div class="overlay" (click)="stay()"></div>
      <div class="popup">
        <div class="popuptop">Are you still there?</div>
        <div class="popupcenter">
          <div>Your session will end in {{ textTimePopup }} minutes due to inactivity.</div>
        </div>
        <div class="popupbottom">
          <div><sp-button [btn]="btn.Secondary" (onClick)="logout()">Sign Out</sp-button></div>
          <div><sp-button [btn]="btn.Primary" (onClick)="stay()">Stay Logged In</sp-button></div>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./session-timeout.component.scss'],
})
export class SessionTimeoutComponent implements OnInit {
  btn = BtnType;
  sessionTimeoutMinutes: number;
  displayPopup = false;
  textTimePopup: string;
  userContext$ = this.userContextService.userContext$;
  popupIntervalPredicate: any;
  timeLeftToDisplayPopup: number;
  maxInactivityTimeToShowPopup: number;
  sessionIntervalPredicate: any;
  popupRunningTimeLeft: number;
  popupTimerDuration: number; // in miliseeconds
  sessionTimeoutSeconds: number;
  popupTimerDurationSeconds = 30;
  defaultTimeoutMinutes = 1;

  clockAtPopupStart: number;

  //* Listening to mouse and keyboard events determines if there is inactivity

  //* for touch devices
  @HostListener('document:touchmove')
  @HostListener('document:touchstart')

  //* for standard devices
  @HostListener('document:mousemove')
  @HostListener('document:mousedown')
  onEvent(event: MouseEvent) {
    this.resetSessionTimeout();
  }

  //* both for touch and standard devices
  @HostListener('document:keydown', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    this.resetSessionTimeout();
  }

  constructor(private authService: SpAuthService, private userContextService: UserContextService) {}

  ngOnInit(): void {
    this.userContext$.subscribe(userContext => {
      this.initializeTimeoutVariables(userContext.sessionTimeout);
      this.startSessionTimer();
    });
  }

  initializeTimeoutVariables(sessionTimeoutMinute: number) {
    this.sessionTimeoutSeconds = sessionTimeoutMinute * 60;

    this.sessionTimeoutSeconds =
      this.sessionTimeoutSeconds === 0
        ? this.defaultTimeoutMinutes * 60
        : this.sessionTimeoutSeconds;

    // converting into miliseconds
    this.maxInactivityTimeToShowPopup =
      (this.sessionTimeoutSeconds - this.popupTimerDurationSeconds) * 1000;
    this.timeLeftToDisplayPopup =
      (this.sessionTimeoutSeconds - this.popupTimerDurationSeconds) * 1000;

    this.clockAtPopupStart = Date.now() + this.timeLeftToDisplayPopup;

    this.popupTimerDuration = this.popupTimerDurationSeconds * 1000;
    this.popupRunningTimeLeft = this.popupTimerDurationSeconds * 1000;
  }

  stay() {
    this.displayPopup = false;
    this.resetSessionTimeout();
    clearInterval(this.popupIntervalPredicate);
    this.popupIntervalPredicate = null;
    this.startSessionTimer();
  }

  resetSessionTimeout() {
    if (!document.hidden && document.hasFocus()) {
      this.timeLeftToDisplayPopup = this.maxInactivityTimeToShowPopup;
      this.clockAtPopupStart = Date.now() + this.timeLeftToDisplayPopup;
    }
  }

  startSessionTimer() {
    this.sessionIntervalPredicate = setInterval(() => {
      this.timeLeftToDisplayPopup = this.timeLeftToDisplayPopup - 1000;

      if (this.clockAtPopupStart < Date.now()) {
        clearInterval(this.sessionIntervalPredicate);
        this.startPopupTimer();
      }
    }, 1000);
  }

  logout() {
    this.authService.logout();
  }

  startPopupTimer() {
    this.displayPopup = true;
    this.popupRunningTimeLeft = this.popupTimerDuration;
    const clockAtLogout = Date.now() + this.popupTimerDuration;
    this.popupIntervalPredicate = setInterval(() => {
      const minutes = Math.floor((this.popupRunningTimeLeft % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((this.popupRunningTimeLeft % (1000 * 60)) / 1000);

      this.textTimePopup =
        (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);

      this.popupRunningTimeLeft = this.popupRunningTimeLeft - 1000;

      if (clockAtLogout < Date.now()) {
        clearInterval(this.popupIntervalPredicate);

        this.logout();
      }
    }, 1000);
  }
}
